import editableTime from "./editableTime.component";

const editableTimeModule = angular
  .module("app.components.editableTime", [])
  .component("editableTime", editableTime);

export default editableTimeModule;



// WEBPACK FOOTER //
// ./src/components/editableTime/editableTime.module.js